import React from 'react';

import { CookiePolicy } from 'components/cookie-policy/CookiePolicy';

export const CookiePolicyPage: React.FC = () => {
    return <CookiePolicy />;
};
